export { fr } from '@payloadcms/translations/languages/fr'
